export const wait = async (n) => {
  await new Promise((resolve) => setTimeout(() => resolve(), n * 1000));
};
